import { createLayoutComponent } from './Layout';
export default createLayoutComponent(true);
